import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.js";
import * as carrousel from "../specific/carrousel.js";
import * as Medias from "../../server/Medias.js";
import Icons from "../../svg/Icons.ts";

export {init}
Html.registerWidget('widget/form/input-images-simple',{init:init})

function init(node){
  var 
    defaultAdd = node.children(),
    currentIdx = 0,
    multiple = true,
    inputName = node.attr('name')||'picture';
  
  node.get(0).style.height=node.height()+'px';
  node.addClass("input-image");
  
  node.append('<ib class="picture-right">'+Icons.ic_chevron_right+'</ib>');
  node.append('<ib class="picture-left">'+Icons.ic_chevron_left+'</ib>');
  node.append('<ib class="picture-delete">'+Icons.ic_close+'</ib>');
  node.append('<ib class="picture-reset">'+Icons.ic_repeat+'</ib>');

  node.append('<ib class="picture-add">'+Icons.ic_camera+'</ib>');
  node.append('<span style="display:inline-block;width:100%;height:100%;overflow:hidden;white-space:nowrap;font-size:0"></span>');
  node.append('<input type="file" accept="image/*" style="display:none" multiple>');
  node.append('<input type="hidden" name="'+inputName+'" value="$empty">');
    
  var 
    addTag = node.find('.picture-add'),
    nextTag = node.find('.picture-right'),
    prevTag = node.find('.picture-left'),
    deleteTag = node.find('.picture-delete'),
    imgContainer = node.find('span'),
    inputFileAdd = node.find('input[type="file"]'),
    inputEmpty = node.find('input[type="hidden"]'),
    originalValues = node.attr("data-value").split(' ').filter(t=>t.length>0);

  function append(value){
    imgContainer.append(
      '<span style="display:inline-block;width:100%;height:100%;transition:all linear 0.3s">'
      +'<img src="'+value.preview+'"/>'
      +'<input type="hidden" name="'+inputName+'" value="'+value.url+'">'
      +'</span>')
    value.node = imgContainer.children().last();  
    value.node.find('input').val(value.url).get(0).file = value.file;
    value.node.find('img').get(0).onerror = function(){
      deleteTag.trigger('click')
    }  
  }
  
  originalValues.forEach(function(url,idx){
    let 
      isInternal = url.indexOf('/media/')>-1,
      hasQuery = url.indexOf('?')>-1;
    append({
      url:url,
      preview:isInternal?(url+(hasQuery?'&':'?')+"w=512&h=512&s=r"):url,
    })
  });
  
  function majUI(){
    var 
      length = imgContainer.children().length,
      hasImg = length>0;
    defaultAdd.toggle(!hasImg)
    
    imgContainer.toggle(hasImg)
    prevTag.toggle(hasImg && currentIdx>0);
    nextTag.toggle(hasImg && currentIdx<length-1);
    deleteTag.toggle(hasImg);
    addTag.toggle(hasImg);
    inputEmpty.prop('disabled',hasImg)
  }
  majUI();
  nextTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    var length = imgContainer.children().length;
    currentIdx = (currentIdx+1)%length;
    carrousel.smoothScrollTo(imgContainer.get(0),currentIdx);
    majUI();
  });
  prevTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    var length = imgContainer.children().length;
    currentIdx = (currentIdx-1+length)%length;
    carrousel.smoothScrollTo(imgContainer.get(0),currentIdx);
    majUI();
  });
  deleteTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    let theNodeToRemove = imgContainer.find('span').get(currentIdx);
    theNodeToRemove.style.width="0";
    setTimeout(function(){
      theNodeToRemove.remove();
      var length = imgContainer.children().length;
      if(currentIdx>=length){
        currentIdx--;
      }
      if(currentIdx<=0){
        currentIdx=0;
      }
      
      majUI();
    },300)
    
  });
  addTag.on("click",function(e){
    multiple = true;
    inputFileAdd.attr('mutiple','mutiple')
  });
  imgContainer.on("click",function(e){
    multiple = false;
    inputFileAdd.removeAttr('mutiple')
  });
  
  inputFileAdd.on('change',async function(){
    if(!await Medias.checkQuota()) return;
    let i=0;
    if(!multiple){
      let currentNode = imgContainer.find('span').get(currentIdx);
      currentNode.querySelector('input').file = this.files[i];
      Redim.thumbnail(this.files[i],{width:node.width(),height:node.height()},function(dataurl){
        currentNode.querySelector('img').src = dataurl;
      },function(){
        currentNode.querySelector('img').src = dataurl;
      })
      i++;
    }
    for(;i<this.files.length;i++){
      const file = this.files[i];
      Redim.thumbnail(file,{width:node.width(),height:node.height()},function(dataurl){
        append({
          preview:dataurl,
          file:file
        });
        //on va au dernier
        currentIdx = imgContainer.children().length-1;
        carrousel.smoothScrollTo(imgContainer.get(0),currentIdx);
        
        majUI();
      },function(){
        console.log(arguments)
      })
    }
    
  });
    
}
 